import isPlainObject from 'lodash/isPlainObject';
/** Cap on distinct captured queries per delivery; overflow beyond this is dropped and counted. */
export const MAX_DELIVERY_QUERIES = 50;
/** Bumped whenever the captureKey hash inputs change, to invalidate stale keys across a deploy. */
export const CAPTURE_KEY_VERSION = 'v1';
/** Labels are display-only; capped at capture time. */
export const MAX_CAPTURE_LABEL_CHARS = 200;
/** Window global MinimalApp publishes and UnfurlService reads. */
export const DELIVERY_CAPTURE_GLOBAL = '__lightdashAppDeliveryCapture';
const isNullableString = (value) => value === null || typeof value === 'string';
/** Rejects NaN/Infinity/-Infinity as well as non-numbers — every numeric
 *  field here crosses an untrusted page.evaluate() boundary. */
const isFiniteNumber = (value) => typeof value === 'number' && Number.isFinite(value);
const isNullableFiniteNumber = (value) => value === null || isFiniteNumber(value);
const parseCapturedQuery = (value) => {
    if (!isPlainObject(value))
        return null;
    const candidate = value;
    const { status, captureKey, label, exploreName, order } = candidate;
    if (typeof captureKey !== 'string')
        return null;
    if (typeof label !== 'string' || label.length > MAX_CAPTURE_LABEL_CHARS) {
        return null;
    }
    if (!isNullableString(exploreName))
        return null;
    if (!isFiniteNumber(order))
        return null;
    if (status === 'ready') {
        const { queryUuid, rowCount, limitReached } = candidate;
        if (typeof queryUuid !== 'string')
            return null;
        if (!isNullableFiniteNumber(rowCount))
            return null;
        if (typeof limitReached !== 'boolean')
            return null;
        return {
            status: 'ready',
            captureKey,
            label,
            exploreName,
            queryUuid,
            order,
            rowCount,
            limitReached,
        };
    }
    if (status === 'error') {
        const { queryUuid, error } = candidate;
        if (!isNullableString(queryUuid))
            return null;
        if (typeof error !== 'string')
            return null;
        return {
            status: 'error',
            captureKey,
            label,
            exploreName,
            queryUuid,
            order,
            error,
        };
    }
    return null;
};
/**
 * Fail-closed validator for the manifest MinimalApp publishes on
 * `DELIVERY_CAPTURE_GLOBAL` and UnfurlService reads via page.evaluate. Any
 * structural mismatch returns `null` — callers must treat that as a hard
 * failure, not an empty manifest.
 */
export const parseDeliveryCaptureManifest = (value) => {
    if (!isPlainObject(value))
        return null;
    const candidate = value;
    if (candidate.version !== 1)
        return null;
    if (!Array.isArray(candidate.items))
        return null;
    if (candidate.items.length > MAX_DELIVERY_QUERIES)
        return null;
    const { overflowCount } = candidate;
    if (!isFiniteNumber(overflowCount) || overflowCount < 0)
        return null;
    const items = [];
    for (const item of candidate.items) {
        const parsed = parseCapturedQuery(item);
        if (!parsed)
            return null;
        items.push(parsed);
    }
    return {
        version: 1,
        items,
        overflowCount,
    };
};
//# sourceMappingURL=deliveryCapture.js.map